import React, { useState } from "react";
import { Modal, Form, Input, Button, message, Row, Col, Select } from "antd";

const { Option } = Select;

const CreateTransfertModal = ({ visible, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      console.log(values);

      message.success("Marchand créé avec succès ! 🎉");
      form.resetFields();
      onClose();
    } catch (err) {
      message.error("❌ Une erreur est survenue");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <div>
          <div style={{ fontWeight: 600 }}>Transfert commission</div>
          <div style={{ fontSize: "12px", color: "#888" }}>
            Renseignez les informations du bénéficiaire
          </div>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Annuler
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
          Créer
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">

        {/* Nom + Prénom */}
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              label="Nom"
              name="lastName"
              rules={[{ required: true, message: "Veuillez entrer le nom" }]}
            >
              <Input placeholder="Nom" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Prénom"
              name="firstName"
              rules={[{ required: true, message: "Veuillez entrer le prénom" }]}
            >
              <Input placeholder="Prénom" />
            </Form.Item>
          </Col>
        </Row>

        {/* Email + Téléphone */}
        <Row gutter={12}>
          <Col span={12}>
          

  {/* SOLDE DISPONIBLE */}
      <Form.Item label="Solde disponible">
        <Input
          //value={commissionTotale?.toLocaleString("fr-FR")}
          readOnly
          style={{
            backgroundColor: "#fafafa",
            color: "#999",
            fontWeight: 500
          }}
          addonAfter={
            <span style={{ color: "#bbb", fontSize: "12px" }}>
              XOF
            </span>
          }
        />
      </Form.Item>
      </Col>

          <Col span={12}>
            <Form.Item
            label="Montant demandé"
            name="amount"
           
          
          >
            <Input
              placeholder="Entrer le montant"
              type="number"
              addonAfter={
                <span style={{ color: "#bbb", fontSize: "12px" }}>
                  XOF
                </span>
              }
            />
          </Form.Item>
          </Col>
        </Row>

        {/* Select (exemple) */}
        <Form.Item
          label="Type de transfert"
          name="type"
          rules={[{ required: true, message: "Veuillez sélectionner un type" }]}
        >
          <Select placeholder="Choisir un type">
            <Option value="bank">Virement bancaire</Option>
            <Option value="mobile">Mobile money</Option>
          </Select>
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default CreateTransfertModal;